<template>
  <div class="mt-1">
    <loadingCube v-if="!loaded" :loadingMessage="'TIMESHEET SETUP'"></loadingCube>
    <div v-show="loaded" class="row mb-3">
      <div class="col-12">
        <h2 class="bp-color">Timesheet Portal Setup</h2>
        <p class="mb-4">This page is used to manage sites on your timesheet submissions.<br>It allows you to update the active sites you have contractor working at, informing
          Genius at the same time what VAT percentage is applicable for the site.</p>
      </div>
      <div class="col-12">
        <ValidationObserver ref="saveTimesheetSetup" slim>
          <form role="form" @submit.prevent="save_timesheet_setup">

            <div class="row">
              <div class="col-12">
                <b-card header="SITE SETUP" header-tag="h4" body-class="mb-3 pb-0 record_card_body">

                  <div class="row">
                    <div class="col-md-8">
                      <p class="font-weight-bold mb-0" style="line-height: 40px">Please select the number of sites you need to enter hours for.</p>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <ValidationProvider rules="required" v-slot="{errors, classes}" name="Number of Sites" tag="div">
                          <label class="form-label" for="number_sites">Number of Sites</label>
                          <multiselect v-model="timesheet.number_sites" id="number_sites" name="number_sites" placeholder="" :options="ms_options.number_sites"
                                       class="requiredField" :class="classes" @input="inputNumberOfSites"></multiselect>
                          <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                    </div>

                    <div class="col-12">
                      <hr style="margin-bottom:30px;">
                    </div>

                    <div v-for="n in parseInt(timesheet.number_sites)" class="col-12">
                      <div class="row">
                        <div class="col-lg-7">
                          <div class="form-group">
                            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Site ' + n + ' Name'" tag="div">
                              <label class="form-label" :for="'site_name' + n">Site {{ n }} Name</label>
                              <input type="text" v-model="timesheet.site_name[n]" :id="'site_name' + n" :name="'site_name' + n" class="form-input requiredField" :class="classes">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <div class="form-group">
                            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Site ' + n + 'VAT'" tag="div">
                              <label class="form-label" :for="'site_vat' + n">Site {{ n }} VAT</label>
                              <multiselect v-model="timesheet.site_vat[n]" :id="'site_vat' + n" :name="'site_vat' + n" placeholder=""
                                           :options="ms_options.site_vat" class="requiredField" :class="classes"></multiselect>
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <!--                                            <div class="form-group">-->
                          <!--                                              <multiselect v-model="timesheet.site_vat[n]" :name="'site_vat' + n" :id="'site_vat' + n" :placeholder="'Select Site ' + n + ' VAT'"-->
                          <!--                                                           :options="ms_options.site_vat"-->
                          <!--                                                           v-validate="'required'" :data-vv-name="'site_vat' + n" :data-vv-as="'Site ' + n + ' VAT'"></multiselect>-->
                          <!--                                              <span class="floating-label">Site {{ n }} VAT</span>-->
                          <!--                                              <div v-show="errors.has('site_vat' + n)" class="vvERROR"><i class="fa fa-warning"></i> <span class="help is-danger">{{ errors.first('site_vat' + n) }}</span>-->
                        </div>

                        <div class="col-lg-2">
                          <div class="form-group text-right">
                            <button class="btn btn_remove_site" @click.prevent="remove_site(n, timesheet.site_name[n])" v-if="timesheet.number_sites > 1">
                              <i class="far fa-times-circle"></i> Remove Site {{ n }}
                            </button>
                          </div>
                        </div>

                        <div class="col-12 mt-1" v-if="timesheet.site_vat[n] === '0%' || timesheet.site_vat[n] === '5%'" style="margin-top: -10px">
                          <div class="form-group mb-4" style="color: #f6993f; font-size: 12px; line-height: 20px;">
                            <i class="fas fa-exclamation-triangle"></i> Please ensure you provide Genius Money with documentation verifying the VAT status of site -
                            {{ timesheet.site_name[n] }}.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3 mb-2">
                    <div class="col-12">
                      <button type="submit" class="btn orcaBtn w-100" :disabled="saving">
                        <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>SAVING SITE SETUP ...</span>
                        <span v-else>SAVE SITE SETUP</span>
                      </button>
                    </div>
                  </div>
                </b-card>
              </div>

            </div>

          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>
<script>
import loadingCube from "loaders/record_loader";
import Multiselect from 'vue-multiselect';

export default {
  name: "c_timesheet_setup",
  components: {
    loadingCube,
    Multiselect,
  },
  data() {
    return {
      loaded: false,
      saving: false,
      logged_in_user: {},
      company_id: "",

      ms_options: {
        number_sites: [
          '1', '2', '3', '4', '5', '6', '7', '8', '9', '10',
          '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
          '21', '22', '23', '24', '25', '26', '27', '28', '29', '30',
          '31', '32', '33', '34', '35'
        ],
        site_vat: ['0%', '5%', '20%'],
      },
      timesheet: {
        number_sites: 1,
        site_name: [],
        site_vat: [],
      },
    }
  },
  created() {
    // axios.get('/client/get/website_user').then(response => {
    this.logged_in_user = this.$store.state.auth.me;

    axios.get(this.crmApiPath + 'contact/' + this.$store.state.auth.me.contact_id).then(res => {
      this.company_id = res.data.company_id;

      axios.get(this.crmApiPath + 'timesheet_setup/contact/' + res.data.company_id).then(setup => {
        if (this.notEmptyObject(setup.data)) {
          let keys = Object.keys(setup.data), j = 1, k = 1;
          for (let i = 0; i < keys.length; i++) {
            if (setup.data[keys[i]] !== null && keys[i] !== 'id' && keys[i] !== 'number_sites' && keys[i] !== 'company_id' && keys[i] !== 'created_at' && keys[i] !==
                'updated_at' && keys[i] !== 'created_by' && keys[i] !== 'created_by_type') {
              if (keys[i].includes('name')) {
                this.timesheet.site_name[j] = setup.data[keys[i]];
                j++;
              }
              if (keys[i].includes('vat')) {
                this.timesheet.site_vat[k] = setup.data[keys[i]];
                k++;
              }
            }
          }
          this.timesheet.number_sites = 0;
          this.timesheet.number_sites = setup.data.number_sites;
        }

        this.$nextTick(() => this.loaded = true)
      })
    })
  },
  methods: {
    remove_site(site, site_name) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Remove Site ' + site + '</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you want to remove this site:<br>' +
            +site_name +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-trash-alt"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.timesheet.site_name.splice(site, 1);
              this.timesheet.site_vat.splice(site, 1);
              this.timesheet.number_sites = this.timesheet.number_sites - 1;
              this.$snotify.remove(toast.id);
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    inputNumberOfSites(val) {
      this.timesheet.site_name.length = parseInt(val) + 1;
      this.timesheet.site_vat.length = parseInt(val) + 1;
    },
    save_timesheet_setup() {
      this.$refs.saveTimesheetSetup.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.saveTimesheetSetup);
        }
        else {
          this.saving = true;
          for (let i = 1; i <= 35; ++i) {
            this["site_" + i + "_name"] = null;
            this["site_" + i + "_vat"] = null;
            if (i in this.timesheet.site_name) {
              this["site_" + i + "_name"] = this.timesheet.site_name[i];
              this["site_" + i + "_vat"] = this.timesheet.site_vat[i];
            }
          }

          axios.post(this.crmApiPath + 'timesheet_setup', {
            company_id: this.company_id,
            number_sites: this.timesheet.number_sites,

            site_1_name: this["site_1_name"], site_1_vat: this["site_1_vat"], site_2_name: this["site_2_name"], site_2_vat: this["site_2_vat"],
            site_3_name: this["site_3_name"], site_3_vat: this["site_3_vat"], site_4_name: this["site_4_name"], site_4_vat: this["site_4_vat"],
            site_5_name: this["site_5_name"], site_5_vat: this["site_5_vat"], site_6_name: this["site_6_name"], site_6_vat: this["site_6_vat"],
            site_7_name: this["site_7_name"], site_7_vat: this["site_7_vat"], site_8_name: this["site_8_name"], site_8_vat: this["site_8_vat"],
            site_9_name: this["site_9_name"], site_9_vat: this["site_9_vat"], site_10_name: this["site_10_name"], site_10_vat: this["site_10_vat"],
            site_11_name: this["site_11_name"], site_11_vat: this["site_11_vat"], site_12_name: this["site_12_name"], site_12_vat: this["site_12_vat"],
            site_13_name: this["site_13_name"], site_13_vat: this["site_13_vat"], site_14_name: this["site_14_name"], site_14_vat: this["site_14_vat"],
            site_15_name: this["site_15_name"], site_15_vat: this["site_15_vat"], site_16_name: this["site_16_name"], site_16_vat: this["site_16_vat"],
            site_17_name: this["site_17_name"], site_17_vat: this["site_17_vat"], site_18_name: this["site_18_name"], site_18_vat: this["site_18_vat"],
            site_19_name: this["site_19_name"], site_19_vat: this["site_19_vat"], site_20_name: this["site_20_name"], site_20_vat: this["site_20_vat"],
            site_21_name: this["site_21_name"], site_21_vat: this["site_21_vat"], site_22_name: this["site_22_name"], site_22_vat: this["site_22_vat"],
            site_23_name: this["site_23_name"], site_23_vat: this["site_23_vat"], site_24_name: this["site_24_name"], site_24_vat: this["site_24_vat"],
            site_25_name: this["site_25_name"], site_25_vat: this["site_25_vat"], site_26_name: this["site_26_name"], site_26_vat: this["site_26_vat"],
            site_27_name: this["site_27_name"], site_27_vat: this["site_27_vat"], site_28_name: this["site_28_name"], site_28_vat: this["site_28_vat"],
            site_29_name: this["site_29_name"], site_29_vat: this["site_29_vat"], site_30_name: this["site_30_name"], site_30_vat: this["site_30_vat"],
            site_31_name: this["site_31_name"], site_31_vat: this["site_31_vat"], site_32_name: this["site_32_name"], site_32_vat: this["site_32_vat"],
            site_33_name: this["site_33_name"], site_33_vat: this["site_33_vat"], site_34_name: this["site_34_name"], site_34_vat: this["site_34_vat"],
            site_35_name: this["site_35_name"], site_35_vat: this["site_35_vat"],

            created_by: this.logged_in_user.contact_id,
            created_by_type: 'Company Contact'
          }).then(() => {
            this.$snotify.success('Timesheet Setup Saved');
            this.$nextTick(() => this.saving = false);
          });
        }
      });
    }
  }
}
jQuery(document).ready(function () {
  let $form_input = $('.form-input');
  $form_input.focus(function () {
    $(this).parents('.form-group').addClass('focused');
  });
  $form_input.blur(function () {
    let inputValue = $(this).val();
    if (inputValue === "") {
      $(this).removeClass('filled');
      $(this).parents('.form-group').removeClass('focused');
    }
    else {
      $(this).addClass('filled');
    }
  });
});
</script>
<style lang="scss">

.clientProfile {
  .card {
    position:         relative;
    display:          flex;
    flex-direction:   column;
    min-width:        0;
    word-wrap:        break-word;
    background-color: #ffffff;
    background-clip:  border-box;
    border:           2px solid rgba(230, 0, 126, 1);
    border-radius:    0.25rem;
    box-shadow:       none;
    opacity:          1;
    padding:          1rem 0 1rem;
    margin-bottom:    1.5rem;
  }

  .cardTitle {
    position:       absolute;
    top:            -16px;
    font-weight:    bold;
    background:     #ffffff;
    padding-left:   5px;
    padding-right:  5px;
    text-transform: uppercase;
  }
}

.btn_remove_site {
  padding:     0 10px;
  height:      38px;
  line-height: 38px;
  width:       auto;
  color:       $red;
  font-size:   0.6rem;

  &.focus, &:focus, &:hover, &.active, &:active, &.active.focus, &.active:focus, &.active:hover, &:active.focus, &:active:focus, &:active:hover {
    background-color: $red;
    color:            $white;
  }
}

.showTimesheet {
  position:  absolute;
  top:       5px;
  right:     5px;
  font-size: 0.7em;
}

.hourRateMultiS {
  width:   125px;
  display: inline-block;
  float:   left;
}
</style>
